import * as React from 'react'

import { DARK_COLORS, DARK_TONES, LIGHT_COLORS, LIGHT_TONES } from '../../constants/colors'
import * as THEMES from '../../constants/theme'
import { Brush, Moon, Sun } from '../../icons'
import { ModalWrapper } from '../modal-wrapper'
import { H6 } from '../texts'
import { Styled } from './styled'
import { ThemeTones } from './theme-tones'

export const ThemesDialog = (props) => {
  const {
    darkTone,
    lightTone,
    changeTone, // ('dark' | 'light', tone)
    onClose
  } = props;
  const darkTones = [
    { name: 'night', colors: DARK_COLORS },
    ...Object.entries(DARK_TONES).map(([name, colors]) => { return { name, colors }})
  ]
  const lightTones = [
    { name: 'day', colors: LIGHT_COLORS },
    ...Object.entries(LIGHT_TONES).map(([name, colors]) => { return { name, colors }})
  ]

  return (
    // eslint-disable-next-line react/jsx-no-bind
    <ModalWrapper onExit={() => onClose()}>
      <Styled.Container>
        <Styled.Themes>
          <Styled.Header>
            <Brush />
            <H6>Themes</H6>
          </Styled.Header>
          <ThemeTones
            Icon={Moon}
            tones={darkTones}
            themeTone={darkTone}
            theme={THEMES.DARK_THEME.name}
            changeTone={changeTone}
          />
          <ThemeTones
            Icon={Sun}
            tones={lightTones}
            themeTone={lightTone}
            theme={THEMES.LIGHT_THEME.name}
            changeTone={changeTone}
          />
        </Styled.Themes>
      </Styled.Container>
    </ModalWrapper>
  )
}
